// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleBreadcrumbs_root__3F7D3","stepContainer":"SimpleBreadcrumbs_stepContainer__3aC4m","header":"SimpleBreadcrumbs_header__lIFI4"};